/**
 * TagGroup.jsx
 *
 * @Author: zhangce
 * @Date: 18/8/7 下午5:35
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tag from './Tag';

/**
 * TagGroup
 * */
class TagGroup extends React.PureComponent {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 类名
     * */
    className: PropTypes.string,
    /**
     * 默认值
     * */
    defaultValue: PropTypes.array,
    /**
     * 标签样式类型
     * */
    tagType: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error', 'info']),
    /**
     * 添加新标签按钮的文案说明
     * */
    addText: PropTypes.string,
    /**
     * 值改变时回调函数
     * */
    onChange: PropTypes.func,
    /**
     * 是否显示添加按钮
     * */
    hasAddableTag: PropTypes.bool,
    /**
     * 创建新标签的键值
     * */
    enterKey: PropTypes.array,
    /**
     * 自动聚焦input框
     * */
    autoTriggerAdd: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
  };

  static defaultProps = {
    prefixCls: 'ne-tag-group',
    defaultValue: [],
    tagType: 'error',
    addText: '+ new Tag',
    hasAddableTag: true,
    autoTriggerAdd: false,
    size: 'medium',
  };

  static getDerivedStateFromProps(props, state) {
    if (props.defaultValue !== state.prevDefaultValue) {
      return {
        tags: props.defaultValue,
        prevDefaultValue: props.defaultValue,
      };
    }
    return null;
  }

  constructor(props, context) {
    super(props, context);
    const { defaultValue } = props;
    this.state = {
      tags: defaultValue,
      prevDefaultValue: defaultValue,
    };
  }

  handleClose = tagRemove => {
    const { onChange } = this.props;
    const { tags } = this.state;
    const newTags = tags.filter(tag => tag !== tagRemove);
    this.setState({ tags: newTags });
    onChange && onChange(newTags);
  };

  createNewTag = inputValue => {
    const { onChange } = this.props;
    const { tags } = this.state;
    if (!tags.includes(inputValue)) {
      const newTags = [...tags, inputValue];
      onChange && onChange(newTags);
      this.setState({ tags: newTags });
    }
    return true;
  };

  triggerAddTagClick = e => {
    const { autoTriggerAdd } = this.props;
    if (autoTriggerAdd && this.addTag) {
      this.addTag.setInput(e);
    }
  };

  getContainer = el => {
    this.tagContainer = el;
  };

  render() {
    const {
      tagType,
      addText,
      className,
      children,
      hasAddableTag,
      enterKey,
      prefixCls,
      size,
      onChange,
      autoTriggerAdd,
      ...other
    } = this.props;
    const { tags } = this.state;

    return (
      <div
        className={classNames(`${prefixCls}`, className, `${prefixCls}-${size}`)}
        onClick={this.triggerAddTagClick}
        {...other}>
        {tags.map(tag => (
          <Tag key={tag} closable onClose={this.handleClose}>
            {tag}
          </Tag>
        ))}
        {hasAddableTag && (
          <Tag isAddableTag onCreate={this.createNewTag} enterKey={enterKey}>
            {addText}
          </Tag>
        )}
      </div>
    );
  }
}

export default TagGroup;



// WEBPACK FOOTER //
// ./src/tag/TagGroup.jsx